import EmptyState from "@/components/EmptyState";
import { ListChecks, BookOpen, Circle, FileText, Lock, ChevronRight } from "lucide-react";

export function PlaybookTab({ stages, guidance, onOpenGuidance }) {
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-3 flex items-center gap-1.5"><ListChecks className="h-3.5 w-3.5" /> Standard Matter Lifecycle — {stages.length} stages</div>
        <div className="space-y-3" data-testid="template-stages">
          {stages.map((s, i) => (
            <div key={s.key} className="border border-border bg-card rounded-sm p-4">
              <div className="flex items-center gap-2">
                <span className="grid place-items-center h-6 w-6 rounded-full bg-brand-red-grad text-primary-foreground text-xs font-bold">{i + 1}</span>
                <span className="text-sm font-semibold">{s.name}</span>
              </div>
              <p className="text-xs text-muted-foreground mt-1 ml-8">{s.description}</p>
              <ul className="mt-2 ml-8 space-y-1">
                {s.items.map((it) => <li key={it} className="flex items-start gap-2 text-sm text-foreground/80"><Circle className="h-2 w-2 mt-1.5 fill-primary text-primary shrink-0" />{it}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-3 flex items-center gap-1.5"><BookOpen className="h-3.5 w-3.5" /> Guidance & Standards</div>
        {guidance.length === 0 ? (
          <EmptyState icon={FileText} title="No guidance yet" />
        ) : (
          <div className="space-y-2" data-testid="matter-guidance">
            {guidance.map((a) => (
              <button key={a.id} data-testid="guidance-item" onClick={() => onOpenGuidance({ ...a, description: (a.tags || []).join(" · ") })}
                className="w-full text-left flex items-center gap-3 border border-border bg-card p-3.5 rounded-sm hover:border-primary transition-colors">
                <Lock className="h-3.5 w-3.5 text-primary shrink-0" />
                <span className="flex-1 min-w-0 text-sm font-medium truncate">{a.title}</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
